import { render, staticRenderFns } from "./Payout.vue?vue&type=template&id=12e6666a&scoped=true&"
import script from "./Payout.vue?vue&type=script&lang=ts&"
export * from "./Payout.vue?vue&type=script&lang=ts&"
import style0 from "./Payout.vue?vue&type=style&index=0&id=12e6666a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e6666a",
  null
  
)

export default component.exports